<div class="gp-estimator-page">
    <form [formGroup]="form">
        <!-- Page head -->
        <div class="page-head">
            <div class="page-title">
                <h1>GP Estimator <span class="subtle">— new placement</span></h1>
            </div>
            <div class="head-actions">
                <button type="button" class="btn btn-primary" (click)="openImportModal()">
                    <i class="bi bi-upload"></i> Import Medical Rates
                </button>
                <button type="button" class="btn btn-primary" (click)="openViewModal()">
                    <i class="bi bi-table"></i> View Medical Rates
                </button>
                <button type="button" class="btn btn-outline" (click)="reset()">
                    <i class="bi bi-arrow-counterclockwise"></i> Reset
                </button>
            </div>
        </div>

        <!-- Context strip -->
        <div class="context-strip">
            <div class="context-field">
                <label>Client</label>
                <input type="text" formControlName="client" placeholder="—" />
            </div>
            <div class="context-field">
                <label>Candidate</label>
                <input type="text" formControlName="candidate_name" placeholder="—" />
            </div>
            <div class="context-indicator" *ngIf="calculating">
                <span class="spinner-border spinner-border-sm"></span>
                <span>Calculating…</span>
            </div>
        </div>

        <div class="split">
            <!-- LEFT: inputs -->
            <div class="split-left">
                <!-- Rates & Duration -->
                <div class="card" [class.collapsed]="!cardsOpen.rates" [class.active]="cardsOpen.rates">
                    <div class="card-head" (click)="toggleCard('rates')">
                        <span class="icon blue"><i class="bi bi-sliders"></i></span>
                        <span class="title">Rates & Duration</span>
                        <span class="meta" *ngIf="result">
                            Bill ${{ form.get('bill_rate')?.value | number:'1.0-2' }} ·
                            Pay ${{ form.get('pay_rate')?.value | number:'1.0-2' }} ·
                            {{ form.get('contract_weeks')?.value }} wks
                        </span>
                        <i class="bi bi-chevron-down chev"></i>
                    </div>
                    <div class="card-body">
                        <!-- Bill rate with slider -->
                        <div class="field field-slider">
                            <label>Bill Rate <small>/hr</small> <span class="req">*</span></label>
                            <div class="slider-wrap">
                                <div class="input-with-prefix">
                                    <span class="prefix">$</span>
                                    <input type="number" formControlName="bill_rate" min="0" step="0.01"
                                        placeholder="0.00" />
                                </div>
                                <input type="range" min="0" max="200" step="0.5"
                                    [value]="form.get('bill_rate')?.value || 0" (input)="onBillSlider($event)" />
                            </div>
                        </div>

                        <!-- Pay rate with slider -->
                        <div class="field field-slider">
                            <label>Pay Rate <small>/hr</small> <span class="req">*</span></label>
                            <div class="slider-wrap">
                                <div class="input-with-prefix">
                                    <span class="prefix">$</span>
                                    <input type="number" formControlName="pay_rate" min="0" step="0.01"
                                        placeholder="0.00" />
                                </div>
                                <input type="range" min="0" max="150" step="0.5"
                                    [value]="form.get('pay_rate')?.value || 0" (input)="onPaySlider($event)" />
                            </div>
                        </div>

                        <div class="grid-3">
                            <div class="field">
                                <label>VMS Fee <small>/hr</small></label>
                                <input type="number" formControlName="vms_fee" min="0" step="0.01" placeholder="0.00" />
                            </div>
                            <div class="field">
                                <label>Pay Type <span class="req">*</span></label>
                                <div class="segmented" role="group">
                                    <input type="radio" class="btn-check" id="pt-w2" formControlName="pay_type"
                                        value="W2" />
                                    <label for="pt-w2">W2</label>
                                    <input type="radio" class="btn-check" id="pt-1099" formControlName="pay_type"
                                        value="1099" />
                                    <label for="pt-1099">1099</label>
                                </div>
                            </div>
                            <div class="field">
                                <label>Bonus <small>(one-time)</small></label>
                                <input type="number" formControlName="bonus" min="0" step="0.01" placeholder="0.00" />
                            </div>
                        </div>

                        <div class="grid-3 mt-3">
                            <div class="field">
                                <label>Contract Weeks <span class="req">*</span></label>
                                <input type="number" formControlName="contract_weeks" min="0" step="1"
                                    placeholder="0" />
                            </div>
                            <div class="field">
                                <label>Hours <small>/week</small> <span class="req">*</span></label>
                                <div class="segmented segmented-buttons">
                                    <button *ngFor="let p of hourPresets" type="button" class="seg"
                                        [class.active]="isHoursPreset(p)" (click)="setHoursPreset(p)">{{ p }}</button>
                                </div>
                            </div>
                            <div class="field">
                                <label>Custom hrs</label>
                                <input type="number" formControlName="hours_per_week" min="0" max="168" step="0.5"
                                    placeholder="40" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Medical -->
                <div class="card" [class.collapsed]="!cardsOpen.medical">
                    <div class="card-head" (click)="toggleCard('medical')">
                        <span class="icon pink"><i class="bi bi-heart-pulse"></i></span>
                        <span class="title">Medical Insurance</span>
                        <span class="meta meta-action" (click)="$event.stopPropagation()">
                            <span class="meta-label">{{ form.get('medical_participant')?.value ? 'Enrolled' : 'Not
                                enrolled' }}</span>
                            <label class="switch">
                                <input type="checkbox" formControlName="medical_participant" />
                                <span class="slider-toggle"></span>
                            </label>
                        </span>
                        <i class="bi bi-chevron-down chev"></i>
                    </div>
                    <div class="card-body">
                        <ng-container *ngIf="form.get('medical_participant')?.value; else medicalOff">
                            <div class="grid-3">
                                <div class="field">
                                    <label>Candidate age <span class="req">*</span></label>
                                    <input type="number" formControlName="candidate_age" min="0" max="110" step="1"
                                        placeholder="0" />
                                </div>
                                <div class="field field-dependents" formArrayName="dependent_ages">
                                    <label>Dependents <small>(max 5)</small></label>
                                    <div class="dep-chips">
                                        <span class="dep-chip"
                                            *ngFor="let ctrl of dependentAges.controls; let i = index">
                                            <input type="number" [formControlName]="i" placeholder="Age" min="0"
                                                max="110" />
                                            <span class="dep-unit">yrs</span>
                                            <button type="button" class="dep-remove" (click)="removeDependent(i)"
                                                aria-label="Remove">
                                                <i class="bi bi-x"></i>
                                            </button>
                                        </span>
                                        <button type="button" class="btn btn-dash" *ngIf="dependentAges.length < 5"
                                            (click)="addDependent()">
                                            <i class="bi bi-plus-lg"></i> Add
                                        </button>
                                    </div>
                                    <small class="dep-empty text-muted" *ngIf="!dependentAges.length">
                                        No dependents. Add to include their premium.
                                    </small>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #medicalOff>
                            <div class="medical-off">
                                <i class="bi bi-dash-circle"></i>
                                <span>Not a participant</span>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Expenses -->
                <div class="card" [class.collapsed]="!cardsOpen.expenses">
                    <div class="card-head" (click)="toggleCard('expenses')">
                        <span class="icon amber"><i class="bi bi-receipt"></i></span>
                        <span class="title">Placement Expenses</span>
                        <span class="meta">contract totals</span>
                        <i class="bi bi-chevron-down chev"></i>
                    </div>
                    <div class="card-body">
                        <div class="grid-3">
                            <div class="field">
                                <label>Travel</label>
                                <input type="number" formControlName="travel" min="0" step="0.01" placeholder="0.00" />
                            </div>
                            <div class="field">
                                <label>Licensure</label>
                                <input type="number" formControlName="licensure" min="0" step="0.01"
                                    placeholder="0.00" />
                            </div>
                            <div class="field">
                                <label>Additional</label>
                                <input type="number" formControlName="additional" min="0" step="0.01"
                                    placeholder="0.00" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- RIGHT: results panel -->
            <div class="split-right">
                <div class="results-panel" [ngClass]="panelBandClass()">
                    <div class="panel-tabs">
                        <button type="button" [class.active]="view === 'contract'" (click)="setView('contract')">
                            Contract total
                        </button>
                        <button type="button" [class.active]="view === 'weekly'" (click)="setView('weekly')">
                            Weekly
                        </button>
                    </div>

                    <!-- Gauge -->
                    <div class="gauge-wrap">
                        <svg class="gauge-svg" viewBox="0 0 280 170">
                            <path class="gauge-bg" d="M 25 145 A 115 115 0 0 1 255 145" />
                            <path class="gauge-fg" d="M 25 145 A 115 115 0 0 1 255 145"
                                [attr.stroke-dasharray]="gaugeArc" [attr.stroke-dashoffset]="gaugeOffset()" />
                        </svg>
                        <div class="gauge-value">
                            <div class="pct" *ngIf="result">
                                {{ (result.contract.gp_pct * 100) | number:'1.2-2' }}<small>%</small>
                            </div>
                            <div class="pct pct-empty" *ngIf="!result">—.——<small>%</small></div>
                            <div class="band-label">{{ bandLabel() }}</div>
                        </div>
                    </div>
                    <div class="gauge-ticks">
                        <span>0%</span><span>15%</span><span>30%</span><span>45%</span>
                    </div>

                    <!-- KPI row -->
                    <div class="kpi-row">
                        <div class="kpi accent">
                            <div class="k-label">{{ view === 'contract' ? 'Total' : 'Weekly' }} GP</div>
                            <div class="k-value">{{ (currentBreakdown()?.gross_profit ?? 0) |
                                currency:'USD':'symbol':'1.0-0' }}</div>
                        </div>
                        <div class="kpi">
                            <div class="k-label">{{ view === 'contract' ? 'Total' : 'Weekly' }} Revenue</div>
                            <div class="k-value">{{ (currentBreakdown()?.revenue ?? 0) | currency:'USD':'symbol':'1.0-0'
                                }}</div>
                        </div>
                        <div class="kpi">
                            <div class="k-label">Markup</div>
                            <div class="k-value">
                                <span *ngIf="result">{{ (result.inputs.markup_pct * 100) | number:'1.1-1' }}%</span>
                                <span *ngIf="!result" class="k-empty">—</span>
                            </div>
                        </div>
                        <div class="kpi">
                            <div class="k-label">True Bill</div>
                            <div class="k-value">
                                <span *ngIf="result">${{ result.inputs.true_bill_rate | number:'1.2-2'
                                    }}<small>/hr</small></span>
                                <span *ngIf="!result" class="k-empty">—</span>
                            </div>
                        </div>
                    </div>

                    <!-- Waterfall -->
                    <div class="waterfall-section">
                        <div class="section-head">
                            <h3>Breakdown</h3>
                            <span class="hint" *ngIf="!result">Enter rates, weeks and hours to calculate</span>
                        </div>
                        <div class="waterfall" *ngIf="result">
                            <div class="wf-row revenue">
                                <span class="wf-label">Revenue</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar" style="width: 100%;"></div>
                                </div>
                                <span class="wf-value">{{ currentBreakdown()?.revenue | currency:'USD':'symbol':'1.0-0'
                                    }}</span>
                            </div>
                            <div class="wf-row expense">
                                <span class="wf-label">Wages</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar"
                                        [style.width.%]="expenseBarWidth(currentBreakdown()?.wages ?? 0)"></div>
                                </div>
                                <span class="wf-value">−{{ currentBreakdown()?.wages | currency:'USD':'symbol':'1.0-0'
                                    }}</span>
                            </div>
                            <div class="wf-row expense">
                                <span class="wf-label">CGS <small>({{ (result.inputs.cgs_rate * 100) | number:'1.0-1'
                                        }}%)</small></span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar" [style.width.%]="expenseBarWidth(currentBreakdown()?.cgs ?? 0)">
                                    </div>
                                </div>
                                <span class="wf-value">−{{ currentBreakdown()?.cgs | currency:'USD':'symbol':'1.0-0'
                                    }}</span>
                            </div>
                            <div class="wf-row expense" *ngIf="(currentBreakdown()?.bonus ?? 0) > 0">
                                <span class="wf-label">Bonus</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar"
                                        [style.width.%]="expenseBarWidth(currentBreakdown()?.bonus ?? 0)"></div>
                                </div>
                                <span class="wf-value">−{{ currentBreakdown()?.bonus | currency:'USD':'symbol':'1.0-0'
                                    }}</span>
                            </div>
                            <div class="wf-row expense" *ngIf="(currentBreakdown()?.medical ?? 0) > 0">
                                <span class="wf-label">Medical</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar"
                                        [style.width.%]="expenseBarWidth(currentBreakdown()?.medical ?? 0)"></div>
                                </div>
                                <span class="wf-value">−{{ currentBreakdown()?.medical | currency:'USD':'symbol':'1.0-0'
                                    }}</span>
                            </div>
                            <div class="wf-row expense"
                                *ngIf="((currentBreakdown()?.travel ?? 0) + (currentBreakdown()?.licensure ?? 0) + (currentBreakdown()?.additional ?? 0)) > 0">
                                <span class="wf-label">Placement</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar"
                                        [style.width.%]="expenseBarWidth((currentBreakdown()?.travel ?? 0) + (currentBreakdown()?.licensure ?? 0) + (currentBreakdown()?.additional ?? 0))">
                                    </div>
                                </div>
                                <span class="wf-value">
                                    −{{ ((currentBreakdown()?.travel ?? 0) + (currentBreakdown()?.licensure ?? 0) +
                                    (currentBreakdown()?.additional ?? 0)) | currency:'USD':'symbol':'1.0-0' }}
                                </span>
                            </div>
                            <div class="wf-row gp total">
                                <span class="wf-label">Gross Profit</span>
                                <div class="wf-bar-wrap">
                                    <div class="wf-bar" [style.width.%]="gpBarWidth()"></div>
                                </div>
                                <span class="wf-value">{{ currentBreakdown()?.gross_profit |
                                    currency:'USD':'symbol':'1.0-0' }}</span>
                            </div>
                        </div>
                        <div class="waterfall-empty" *ngIf="!result && errorMessage">
                            <i class="bi bi-exclamation-triangle"></i> {{ errorMessage }}
                        </div>
                    </div>

                    <!-- Scenarios -->
                    <div class="scenarios">
                        <div class="s-head">
                            <h3>Compare scenarios</h3>
                            <button type="button" class="s-save"
                                [disabled]="!result || scenarios.length >= scenarioLimit" (click)="saveScenario()">
                                <i class="bi bi-plus-circle"></i> Save current
                            </button>
                        </div>
                        <div class="s-slots">
                            <div class="s-slot active" *ngIf="result">
                                <div class="s-name">Current</div>
                                <div class="s-pct" [ngClass]="result.contract.band">
                                    {{ (result.contract.gp_pct * 100) | number:'1.1-1' }}%
                                </div>
                                <div class="s-sub">
                                    ${{ form.get('bill_rate')?.value | number:'1.0-0' }} bill ·
                                    ${{ form.get('pay_rate')?.value | number:'1.0-0' }} pay
                                </div>
                            </div>
                            <div class="s-slot" *ngFor="let s of scenarios" (click)="applyScenario(s)">
                                <button type="button" class="s-remove" (click)="removeScenario(s.id, $event)"
                                    aria-label="Remove">
                                    <i class="bi bi-x"></i>
                                </button>
                                <div class="s-name">{{ s.name }}</div>
                                <div class="s-pct" [ngClass]="s.band">{{ (s.gpPct * 100) | number:'1.1-1' }}%</div>
                                <div class="s-sub">
                                    ${{ s.billRate | number:'1.0-0' }} bill · ${{ s.payRate | number:'1.0-0' }} pay
                                </div>
                            </div>
                            <div class="s-slot empty" *ngFor="let _ of emptySlots()">
                                <span *ngIf="result"><i class="bi bi-plus-lg"></i>&nbsp;Save slot</span>
                                <span *ngIf="!result">—</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Full breakdown table (expandable) -->
        <div class="breakdown-panel" *ngIf="result">
            <button type="button" class="breakdown-toggle" (click)="showBreakdown = !showBreakdown"
                [attr.aria-expanded]="showBreakdown">
                <i class="bi" [class.bi-chevron-up]="showBreakdown" [class.bi-chevron-down]="!showBreakdown"></i>
                <span>{{ showBreakdown ? 'Hide' : 'Show' }} full breakdown table</span>
            </button>
            <div class="breakdown-body" *ngIf="showBreakdown">
                <table class="breakdown-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th class="text-end">Per Week</th>
                            <th class="text-end">Contract Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Revenue</td>
                            <td class="text-end">{{ result.weekly.revenue | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.revenue | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Wages</td>
                            <td class="text-end">{{ result.weekly.wages | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.wages | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>CGS <small>({{ (result.inputs.cgs_rate * 100) | number:'1.0-2' }}%)</small></td>
                            <td class="text-end">{{ result.weekly.cgs | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.cgs | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Bonus</td>
                            <td class="text-end">{{ result.weekly.bonus | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.bonus | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Medical</td>
                            <td class="text-end">{{ result.weekly.medical | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.medical | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Travel</td>
                            <td class="text-end">{{ result.weekly.travel | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.travel | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Licensure</td>
                            <td class="text-end">{{ result.weekly.licensure | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.licensure | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="expense-row">
                            <td>Additional</td>
                            <td class="text-end">{{ result.weekly.additional | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.additional | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="total-row">
                            <td>Total Expenses</td>
                            <td class="text-end">{{ result.weekly.expenses | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.expenses | currency:'USD':'symbol':'1.2-2' }}</td>
                        </tr>
                        <tr class="gp-row">
                            <td>Gross Profit</td>
                            <td class="text-end">{{ result.weekly.gross_profit | currency:'USD':'symbol':'1.2-2' }}</td>
                            <td class="text-end">{{ result.contract.gross_profit | currency:'USD':'symbol':'1.2-2' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>

    <!-- Import Medical Rates Modal -->
    <div class="gp-modal-backdrop" *ngIf="showImportModal" (click)="closeModals()">
        <div class="gp-modal" (click)="$event.stopPropagation()">
            <div class="gp-modal-head">
                <h2><i class="bi bi-upload"></i> Import Medical Rates</h2>
                <button type="button" class="gp-modal-close" (click)="closeModals()" aria-label="Close">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
            <div class="gp-modal-body">
                <div class="gp-modal-loading" *ngIf="loadingPlan">
                    <span class="spinner-border spinner-border-sm"></span> Loading plan…
                </div>

                <ng-container *ngIf="!loadingPlan">
                    <!-- No active plan: show create form -->
                    <ng-container *ngIf="!activePlan">
                        <div class="gp-empty-state">
                            <i class="bi bi-info-circle"></i>
                            <span>No active medical plan. Create one to import rates against.</span>
                        </div>
                        <form [formGroup]="createPlanForm" (ngSubmit)="submitCreatePlan()" class="gp-modal-form">
                            <div class="field">
                                <label>Plan name <span class="req">*</span></label>
                                <input type="text" formControlName="name" placeholder="e.g. SELECT PLUS DZC4 — 2025" />
                            </div>
                            <div class="grid-2">
                                <div class="field">
                                    <label>Effective from <span class="req">*</span></label>
                                    <input type="date" formControlName="effective_from" />
                                </div>
                                <div class="field">
                                    <label>Effective to <small>(optional)</small></label>
                                    <input type="date" formControlName="effective_to" />
                                </div>
                            </div>
                            <div class="gp-modal-error" *ngIf="createPlanError">
                                <i class="bi bi-exclamation-triangle"></i> {{ createPlanError }}
                            </div>
                            <div class="gp-modal-actions">
                                <button type="button" class="btn btn-outline" (click)="closeModals()">Cancel</button>
                                <button type="submit" class="btn btn-primary"
                                    [disabled]="createPlanForm.invalid || creatingPlan">
                                    <span *ngIf="creatingPlan" class="spinner-border spinner-border-sm me-1"></span>
                                    Create plan
                                </button>
                            </div>
                        </form>
                    </ng-container>

                    <!-- Active plan: show file upload -->
                    <ng-container *ngIf="activePlan">
                        <div class="gp-plan-meta">
                            <div>
                                <div class="gp-plan-label">Active plan</div>
                                <div class="gp-plan-name">{{ activePlan.name }}</div>
                                <div class="gp-plan-sub">
                                    Effective {{ activePlan.effective_from | date:'mediumDate' }}
                                    <span *ngIf="activePlan.effective_to"> – {{ activePlan.effective_to |
                                        date:'mediumDate' }}</span>
                                </div>
                            </div>
                            <span class="gp-plan-badge">Active</span>
                        </div>

                        <div class="gp-hint">
                            <ul class="gp-hint-list">
                                <li>File must have headers <code>age</code> and <code>monthly_premium</code>.</li>
                                <li>Importing replaces all existing rates for this plan.</li>
                            </ul>
                        </div>

                        <label class="gp-dropzone" [class.has-file]="selectedFile">
                            <input type="file" accept=".csv,.txt,.xlsx,.xls" (change)="onFileChange($event)" hidden />
                            <i class="bi" [class.bi-file-earmark-spreadsheet]="selectedFile"
                                [class.bi-cloud-arrow-up]="!selectedFile"></i>
                            <span *ngIf="!selectedFile">Click to choose a CSV or Excel file</span>
                            <span *ngIf="selectedFile" class="gp-dropzone-file">{{ selectedFile.name }}</span>
                        </label>

                        <div class="gp-modal-error" *ngIf="importError">
                            <i class="bi bi-exclamation-triangle"></i> {{ importError }}
                        </div>

                        <div class="gp-import-result" *ngIf="importResult">
                            <div class="gp-import-summary">
                                <i class="bi bi-check-circle"></i>
                                <span><strong>{{ importResult.imported }}</strong> rates imported.</span>
                                <span *ngIf="importResult.skipped?.length" class="gp-skipped">
                                    {{ importResult.skipped.length }} row(s) skipped.
                                </span>
                            </div>
                            <div class="gp-skipped-list" *ngIf="importResult.skipped?.length">
                                <div class="gp-skipped-head">Skipped rows</div>
                                <div class="gp-skipped-row" *ngFor="let s of importResult.skipped">
                                    <span class="gp-skipped-num">Row {{ s.row }}</span>
                                    <span class="gp-skipped-err">{{ s.errors.join('; ') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="gp-modal-actions">
                            <button type="button" class="btn btn-outline" (click)="closeModals()">Close</button>
                            <button type="button" class="btn btn-primary" [disabled]="!selectedFile || importing"
                                (click)="submitImport()">
                                <span *ngIf="importing" class="spinner-border spinner-border-sm me-1"></span>
                                Upload & import
                            </button>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>

    <!-- View Medical Rates Modal -->
    <div class="gp-modal-backdrop" *ngIf="showViewModal" (click)="closeModals()">
        <div class="gp-modal gp-modal-wide" (click)="$event.stopPropagation()">
            <div class="gp-modal-head">
                <h2><i class="bi bi-table"></i> Medical Rates</h2>
                <button type="button" class="gp-modal-close" (click)="closeModals()" aria-label="Close">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>
            <div class="gp-modal-body">
                <div class="gp-modal-loading" *ngIf="loadingPlan">
                    <span class="spinner-border spinner-border-sm"></span> Loading…
                </div>

                <ng-container *ngIf="!loadingPlan">
                    <div class="gp-empty-state" *ngIf="!activePlan">
                        <i class="bi bi-info-circle"></i>
                        <span>No active medical plan yet. Use <strong>Import Medical Rates</strong> to create
                            one.</span>
                    </div>

                    <ng-container *ngIf="activePlan">
                        <div class="gp-plan-meta">
                            <div>
                                <div class="gp-plan-label">Active plan</div>
                                <div class="gp-plan-name">{{ activePlan.name }}</div>
                                <div class="gp-plan-sub">
                                    Effective {{ activePlan.effective_from | date:'mediumDate' }}
                                    <span *ngIf="activePlan.effective_to"> – {{ activePlan.effective_to |
                                        date:'mediumDate' }}</span>
                                    · {{ activePlan.rates?.length || 0 }} rate(s)
                                </div>
                            </div>
                            <span class="gp-plan-badge">Active</span>
                        </div>

                        <div class="gp-modal-error" *ngIf="viewError">
                            <i class="bi bi-exclamation-triangle"></i> {{ viewError }}
                        </div>

                        <div class="gp-empty-state" *ngIf="!activePlan.rates?.length && !viewError">
                            <i class="bi bi-inbox"></i>
                            <span>No rates uploaded for this plan yet.</span>
                        </div>

                        <div class="gp-modal-error" *ngIf="editError">
                            <i class="bi bi-exclamation-triangle"></i> {{ editError }}
                        </div>

                        <div class="gp-rates-table-wrap" *ngIf="activePlan.rates?.length">
                            <table class="gp-rates-table">
                                <thead>
                                    <tr>
                                        <th>Age</th>
                                        <th class="text-end">Monthly premium</th>
                                        <th class="gp-rates-actions-col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let r of activePlan.rates"
                                        [class.gp-rate-editing]="editingRateUuid === r.uuid">
                                        <td>{{ r.age }}</td>
                                        <td class="text-end">
                                            <span *ngIf="editingRateUuid !== r.uuid">
                                                {{ r.monthly_premium | currency:'USD':'symbol':'1.2-2' }}
                                            </span>
                                            <input *ngIf="editingRateUuid === r.uuid" type="number" min="0" step="0.01"
                                                class="gp-rate-input" [(ngModel)]="editPremium"
                                                [ngModelOptions]="{ standalone: true }" (keydown.enter)="saveEditRate()"
                                                (keydown.escape)="cancelEditRate()" />
                                        </td>
                                        <td class="gp-rates-actions">
                                            <button *ngIf="editingRateUuid !== r.uuid" type="button" class="gp-icon-btn"
                                                (click)="startEditRate(r)" [disabled]="!!editingRateUuid"
                                                title="Edit premium" aria-label="Edit premium">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                            <ng-container *ngIf="editingRateUuid === r.uuid">
                                                <button type="button" class="gp-icon-btn gp-icon-save"
                                                    (click)="saveEditRate()"
                                                    [disabled]="savingRate || !isEditPremiumValid()" title="Save"
                                                    aria-label="Save">
                                                    <span *ngIf="savingRate"
                                                        class="spinner-border spinner-border-sm"></span>
                                                    <i *ngIf="!savingRate" class="bi bi-check-lg"></i>
                                                </button>
                                                <button type="button" class="gp-icon-btn gp-icon-cancel"
                                                    (click)="cancelEditRate()" [disabled]="savingRate" title="Cancel"
                                                    aria-label="Cancel">
                                                    <i class="bi bi-x-lg"></i>
                                                </button>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </ng-container>

                <div class="gp-modal-actions">
                    <button type="button" class="btn btn-outline" (click)="closeModals()">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>